import React from "react";
import VOIPCallButton from "../CallButton/VOIPCallButton";
import PhoneCallButtonFunctional from "../CallButton/PhoneCallButtonFunctional";

export default function CallButton(props) {
	const { callType } = props;
	if (callType === "voip") {
		return <VOIPCallButton {...props} />;
	}
	if (callType === "phone") {
		return <PhoneCallButtonFunctional {...props} />;
	}
	if (callType === "sat") {
		return <PhoneCallButtonFunctional {...props} />;
	}
}
